import { render, staticRenderFns } from "./addCustomerNew.vue?vue&type=template&id=c2ecb9ca&scoped=true"
import script from "./addCustomerNew.vue?vue&type=script&lang=js"
export * from "./addCustomerNew.vue?vue&type=script&lang=js"
import style0 from "./addCustomerNew.vue?vue&type=style&index=0&id=c2ecb9ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ecb9ca",
  null
  
)

export default component.exports